import { GameUIMessageType, StopAutoplayClickedMessage } from 'game-ui-types'
import { useUltraPlayStore } from '@stores/ultraPlayStore'
import { collectUltraPlayWin } from './ultraPlayCollect'
import { ultraPlayAnalytics } from './ultraPlayAnalytics'

export const isUltraPlayPauseBlocked = (): boolean => {
    const up = useUltraPlayStore.getState()

    return up.isBetInFlight || up.hasUnrecordedBet || up.isInFeature || up.isBuyBonusRoundInFlight
}

let pendingBetChange: ((betIndex: number) => void) | null = null

export const deferUltraPlayBetChange = (send: (betIndex: number) => void) => {
    pendingBetChange = send
}

export const clearPendingUltraPlayBetChange = () => {
    pendingBetChange = null
}

const flushPendingUltraPlayBetChange = () => {
    if (!pendingBetChange) return

    const send = pendingBetChange

    pendingBetChange = null
    send(useUltraPlayStore.getState().selectedBetIndex)
}

let pendingBuyBonusChange: (() => void) | null = null

export const deferUltraPlayBuyBonusChange = (apply: () => void) => {
    pendingBuyBonusChange = apply
}

export const clearPendingUltraPlayBuyBonusChange = () => {
    pendingBuyBonusChange = null
}

const flushPendingUltraPlayBuyBonusChange = () => {
    if (!pendingBuyBonusChange) return

    const apply = pendingBuyBonusChange

    clearPendingUltraPlayBuyBonusChange()
    apply()
}

export const executeUltraPlayPause = () => {
    const up = useUltraPlayStore.getState()

    // Tracked here rather than at the button: a blocked pause is deferred and flushed later, and this
    // is the one place both routes converge on — so a pause reports exactly once, when it takes effect.
    ultraPlayAnalytics.sessionPaused()
    up.pause()
    up.setAwaitingAutoplayStop(true)
    collectUltraPlayWin()
    window.postMessage({ type: GameUIMessageType.STOP_AUTOPLAY_CLICKED } as StopAutoplayClickedMessage, '*')
    flushPendingUltraPlayBetChange()
    flushPendingUltraPlayBuyBonusChange()
}

export const requestUltraPlayAutoplayStop = () => {
    const up = useUltraPlayStore.getState()

    up.setPausePending(true)

    // In a feature send the stop now so the engine doesn't charge one more round when it resumes
    // autoplay after the feature. Don't await the confirmation — the pause flushes on feature end.
    if (up.isInFeature) {
        window.postMessage({ type: GameUIMessageType.STOP_AUTOPLAY_CLICKED } as StopAutoplayClickedMessage, '*')

        return
    }

    up.setAwaitingAutoplayStop(true)
    window.postMessage({ type: GameUIMessageType.STOP_AUTOPLAY_CLICKED } as StopAutoplayClickedMessage, '*')
}

export const confirmUltraPlayAutoplayStop = () => {
    const up = useUltraPlayStore.getState()

    if (up.isAwaitingAutoplayStop) up.setAwaitingAutoplayStop(false)
}

export const flushPendingUltraPlayPause = () => {
    const up = useUltraPlayStore.getState()

    // A deferred dropdown change only needs the in-flight round to clear, not a pause — once the
    // session is paused/finished, apply it at the first unblocked opportunity instead of dropping it.
    if (up.status !== 'PLAYING' && !isUltraPlayPauseBlocked()) flushPendingUltraPlayBuyBonusChange()

    if (!up.isPausePending) return

    if (up.status !== 'PLAYING') {
        up.setPausePending(false)
        clearPendingUltraPlayBetChange()

        return
    }

    if (up.isAwaitingAutoplayStop) return

    if (isUltraPlayPauseBlocked()) return

    executeUltraPlayPause()
}
